import { noop } from 'lodash';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { StyledFlex, Tag } from '@dreryk/react-components';

type PatientGroupTagsProps = {
   patient: PatientSimple | null;
};

export const PatientGroupTags = (props: PatientGroupTagsProps): JSX.Element | null => {
   if (!props.patient?.patientGroups) {
      return null;
   }

   return (
      <StyledFlex gap={8} flexWrap={'wrap'}>
         {props.patient.patientGroups.map(({ id, name, primaryColor, darkModeColor }) => {
            return (
               <Tag
                  key={id}
                  lightColor={primaryColor.asHexString()}
                  darkColor={darkModeColor?.asHexString()}
                  testId={`patientGroup-${id}`}
                  onClear={noop}
                  text={name}
                  readonly
               />
            );
         })}
      </StyledFlex>
   );
};
